// extracted by mini-css-extract-plugin
export default {"graph-container":"graph_graph-container__gWtyv","title":"graph_title__jgAI1","arrow-icon":"graph_arrow-icon__L1gDq"};